var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"handle flex items-center w-base cursor-grab active:cursor-grabbing text-signableBrandColours-midGrey hover:text-signableBrandColours-darkGrey",class:{ '!cursor-default !text-signableBrandColours-midGrey': _vm.disabled }},[_c('SixDotsIcon',{attrs:{"aria-hidden":"true"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }